/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Create_Event_Group_MenuInputs */



/**
* | output |
* | --- |
* | "Create Event Group..." |
*
* @param {Markers_Create_Event_Group_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_create_event_group_menu = /** @type {((inputs?: Markers_Create_Event_Group_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Create_Event_Group_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer un groupe d'evenements...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppe erstellen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea gruppo di eventi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать группу событий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear grupo de eventos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建事件组...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループを作成...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप बनाएं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar grupo de eventos...")
	return /** @type {LocalizedString} */ ("Create Event Group...")
});